module.exports = __webpack_public_path__ + "img/pay_w.112f6deb.svg";